var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFolderSimplePlus = function SvgIconFolderSimplePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13.5a1 1 0 0 1 1-1H11v-1.25a1 1 0 1 1 2 0v1.25h1.25a1 1 0 1 1 0 2H13v1.25a1 1 0 1 1-2 0V14.5H9.75a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.513 4.763A1.75 1.75 0 0 1 3.75 4.25h5.001a1.76 1.76 0 0 1 1.043.348l.002.001 2.54 1.901h7.914A1.75 1.75 0 0 1 22 8.25v10.584a1.665 1.665 0 0 1-1.666 1.666H3.75A1.75 1.75 0 0 1 2 18.75V6c0-.464.184-.91.513-1.237M4 6.25V18.5h16v-10h-7.751a1.76 1.76 0 0 1-1.043-.348l-.002-.001-2.54-1.901z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFolderSimplePlus;